import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let image_series_id = useDataValue({
    context: 'images_comparison_action',
    path: 'image_serie_id',
    viewPath: props.viewPath,
  })
  return {
    variables: { image_series_id },
    pause: !image_series_id,
    requestPolicy: 'cache-and-network',
  }
}
